import { createAppAsyncThunk } from '../store/extensions';
import { FeedbackDto } from '@carecircle/core';
import {
  getFeedbackIssueCategoriesCall,
  getFeedbackSuggestionCategoriesCall,
  sendFeedbackCall,
} from './service';

export const sendFeedback = createAppAsyncThunk(
  'identity/feedback',
  (args: { feedback: FeedbackDto }) => {
    return sendFeedbackCall(args.feedback);
  }
);

export const getFeedbackIssueCategories = createAppAsyncThunk(
  'reference/feedbackIssueCategories',
  () => {
    return getFeedbackIssueCategoriesCall();
  }
);

export const getFeedbackSuggestionCategories = createAppAsyncThunk(
  'reference/feedbackSuggestionCategories',
  () => {
    return getFeedbackSuggestionCategoriesCall();
  }
);
